import DOMPurify from 'dompurify'

/**
 * 安全 HTML 包装组件
 * - 使用 DOMPurify 对传入的 HTML 字符串进行净化，防止 XSS
 * - 通过 dangerouslySetInnerHTML 渲染净化后的内容
 *
 * Props:
 * - className?: string                外层容器样式
 * - content: string                   需要渲染的 HTML 字符串
 * - onClick?: (e)=>void               点击回调（事件委托）
 * - suppressWarning?: boolean         是否屏蔽 contentEditable 的 React 警告
 */
const SanitizedHTMLWrapper = ({ className, content, onClick, suppressWarning = false }) => {
  const sanitizedHTML = DOMPurify.sanitize(content)

  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{ __html: sanitizedHTML }}
      suppressContentEditableWarning={suppressWarning}
      onClick={onClick}
    />
  )
}

export default SanitizedHTMLWrapper
